<app-banner>
    <form [formGroup]="loginForm" class="public-page-forms" (ngSubmit)="onSubmit()">
        <h1 class="form-title text-primary" i18n="@@login.login">Meld aan</h1>

        <div class="button-row">
            <button
                type="button"
                class="button-silverfin huge w-full"
                [disabled]="busy"
                (click)="silverfinLoginRedirect()"
                (keypress)="silverfinLoginRedirect()"
            >
                <img class="-my-1 h-10" src="/assets/icons/silverfin.png" />
                <span i18n="@@login.loginSilverfin.icon">Meld aan met Silverfin</span>
            </button>
        </div>

        <div class="relative flex items-center px-2 py-5">
            <div class="flex-grow border-t-2 border-gray-400"></div>
            <span class="mx-4 flex-shrink uppercase text-body" i18n="@@choice.or">of</span>
            <div class="flex-grow border-t-2 border-gray-400"></div>
        </div>

        <div class="input-container mt-5">
            <label for="inputEmail" i18n="@@email">E-mailadres</label>
            <input id="inputEmail" type="email" formControlName="email" class="text-input" required />
        </div>
        <div class="input-container">
            <label for="inputPassword" i18n="@@password">Wachtwoord</label>
            <input id="inputPassword" type="password" formControlName="password" class="text-input" required />
        </div>

        <div class="button-row">
            <button type="submit" class="button-primary huge w-full" [disabled]="!loginForm.valid || busy">
                @if (!busy) {
                    <span i18n="@@login.login">Meld aan</span>
                } @else {
                    <fa-icon [icon]="loadingIcon" [animation]="'spin'"></fa-icon>
                    <ng-container><span i18n="@@login.busyLoggingIn">Bezig met aanmelden…</span></ng-container>
                }
            </button>
        </div>

        <a class="primary-link font-bold" routerLink="/register" i18n="@@login.registerAccount">Registreer een account</a>
        <a class="body-link" routerLink="/reset-password" i18n="@@login.forgotPassword">Wachtwoord vergeten</a>
        <a class="body-link" routerLink="/resend-email" i18n="@@login.resendVerificationEmail">Stuur verificatiemail opnieuw</a>
    </form>
</app-banner>
